// extracted by mini-css-extract-plugin
module.exports = {"slotTool":"EditorSlot_slotTool__zpe2L","popover":"EditorSlot_popover__3Krc0","slotButton":"EditorSlot_slotButton__oJyoX"};